<template>
  <custom-dialog
    class="transfer-order-device-dialog"
    width="800px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    :append-to-body="true"
  >
    <div class="dialog-body">
      <div class="table-bd">
        <custom-table
          height="350px"
          tableCode="transfer_order_device"
          :index="true"
          @filter="filterChange"
          @sort="sortChange"
          :data="tableList"
        ></custom-table>
      </div>
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{$t('Common.com_close')}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
// 查看调拨单/设备信息
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis.js';

export default {
  name: 'transferOrderDevice',
  mixins: [dialogMixins],
  components: {
  },
  props: {
    customShipmentNum: String
  },
  data() {
    return {
      tableList: {},
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        customShipmentNum: '',
      },
      totalRows: null,
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    getTableList() {
      this.$getJSON(apis.transferOrderLogisticsDevicePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
  created() {
  },
  mounted() {
    this.formSearch.customShipmentNum = this.customShipmentNum;
    this.getTableList();
  },
};
</script>

<style>
</style>
